<template>
    <whatsapp-floating-button type-class="wa-float-circle" class="d-none d-sm-inline"></whatsapp-floating-button>
    <div id="bottom-bar" class="d-inline d-sm-none">
        <div class="row">
            <div class="col-2">
                <whatsapp-floating-button type-class="wa-float" class="m-2 ms-4"></whatsapp-floating-button>
            </div>
            <div class="col-9">
                <rondleiding-button size="md"

                ></rondleiding-button>
            </div>
        </div>
    </div>
</template>

<script>

import RondleidingButton from "./RondleidingButton.vue";
import WhatsappFloatingButton from "./WhatsappFloatingButton.vue";

export default {
    components: {WhatsappFloatingButton, RondleidingButton},

    props: [],

    mixins: [],

    data: function () {
        return {
            //
        };
    },

    computed: {
        //
    },

    created() {
        //
    },

    mounted() {
        //
    },

    methods: {
        //
    },

    watch: {
        //
    }
};
</script>
<style lang="scss">
#bottom-bar {
    box-shadow: 0 5px 12px rgb(0 0 0 / 0.5);
    position:fixed;
    padding: 0;
    bottom: 0;
    background-color: white;
    height: 63px;
    width: 100%;
}
</style>
